import { render, staticRenderFns } from "./cadgruposusuarios.vue?vue&type=template&id=3faf4465&"
import script from "./cadgruposusuarios.vue?vue&type=script&lang=js&"
export * from "./cadgruposusuarios.vue?vue&type=script&lang=js&"
import style0 from "./cadgruposusuarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports